// helpers
import { getRequestData } from 'utils/helperMethods';
import {
    API_DOWNLOAD_REPORT,
    API_FETCH_MANDATES,
    API_FETCH_MANDATE_TRANSACTIONS,
    API_GENERATE_REPORT,
    API_GET_ACTIVE_REPORT_MANDATE,
    API_UPDATE_MANDATE,
} from 'utils/API/apiUrls';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { GET, POST } from 'utils/fetchWrappers';

// Actions
import { SUCCESS_MESSAGES } from 'utils/constants/toastMessages';
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as mandateActions from './mandates.actions';

// Constant
import {
    DOWNLOAD_MANDATE_REPORT_REQUEST,
    FETCH_MANDATES_LIST_REQUEST,
    FETCH_MANDATE_TRANSACTION_LIST_REQUEST,
    GENERATE_MANDATE_REPORT_REQUEST,
    GET_ACTIVE_MANDATE_REPORT_REQUEST,
    UPDATE_MANDATE_STATUS_REQUEST,
} from './mandates.constant';

// Libs
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

export function* fetchMandateList(actions) {
    yield put(mandateActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(POST, API_FETCH_MANDATES, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(mandateActions.fetchMandatesSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                mandateActions.fetchMandatesError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            mandateActions.fetchMandatesError({
                error: data,
            })
        );
    }
    yield put(mandateActions.hideLoader());
}

export function* fetchMandateTransactionList(actions) {
    // yield put(mandateActions.showLoader());
    try {
        const { payload } = actions;

        const request = {
            subscriptionId: payload.referenceId,
            paginationDetails: {
                pageNo: payload.pageNo,
                pageSize: payload.pageSize,
            },
        };
        const { data } = yield call(
            POST,
            API_FETCH_MANDATE_TRANSACTIONS,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(mandateActions.fetchMandatesTransactionListSuccess(data));
        } else if (data && data.errorMessage) {
            if (payload.pageNo <= 1) {
                yield put(
                    mandateActions.fetchMandatesTransactionListError({
                        error: data,
                    })
                );
            }
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            mandateActions.fetchMandatesTransactionListError({
                error: data,
            })
        );
    }
    // yield put(mandateActions.hideLoader());
}

export function* updateMandateStatus(actions) {
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_UPDATE_MANDATE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            toast.success(SUCCESS_MESSAGES.MANDATE_STATUS_UPDATE_SUCCESS);
            yield put(mandateActions.updateMandateStatusSuccess(data));
        } else if (data && data.errorMessage) {
            if (data.errorMessage) {
                toast.error(data.errorMessage);
            }
            yield put(
                mandateActions.fetchMandatesTransactionListError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        if (data.errorMessage) {
            toast.error(data.errorMessage);
        }
        yield put(
            mandateActions.fetchMandatesTransactionListError({
                error: data,
            })
        );
    }
}

export function* generateMandateReport(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        let request = {};

        request = getRequestData(payload, true);

        request.reportType = 'MANDATES';

        if (request.merchantCodes) {
            request.merchantIds = request.merchantCodes;
            delete request.merchantCodes;
        }

        const { data } = yield call(POST, API_GENERATE_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(mandateActions.generateMandateReportSuccess(data));
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage || '';
            yield put(
                mandateActions.generateMandateReportError({
                    error: errorMessage || '',
                })
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage || '';
        yield put(
            mandateActions.generateMandateReportError({
                error: errorMessage || '',
            })
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* getActiveMandateReportDetails(actions) {
    const { hideLoader } = actions;
    if (!hideLoader) {
        yield put(loaderActions.showLoader());
    }
    try {
        const { data } = yield call(POST, API_GET_ACTIVE_REPORT_MANDATE, {
            reportType: 'MANDATES',
        });
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(mandateActions.getActiveMandateReportSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                mandateActions.getActiveMandateReportError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;

        yield put(
            mandateActions.getActiveMandateReportError({
                error: data,
            })
        );
    }
    if (!hideLoader) {
        yield put(loaderActions.hideLoader());
    }
}

export function* downloadMandateReportRequest(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            requestId: payload.requestId,
            reportType: 'MANDATES',
        };
        const { data } = yield call(POST, API_DOWNLOAD_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                mandateActions.downloadMandateReportSuccess(data.fileUrl)
            );
            if (data.fileUrl) {
                const link = document.createElement('a');
                link.href = data.fileUrl;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else if (data && data.errorMessage) {
            yield put(
                mandateActions.downloadMandateReportError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            mandateActions.downloadMandateReportError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* mandateSaga() {
    yield takeLatest(FETCH_MANDATES_LIST_REQUEST, fetchMandateList);
    yield takeLatest(
        FETCH_MANDATE_TRANSACTION_LIST_REQUEST,
        fetchMandateTransactionList
    );
    yield takeLatest(UPDATE_MANDATE_STATUS_REQUEST, updateMandateStatus);
    yield takeLatest(GENERATE_MANDATE_REPORT_REQUEST, generateMandateReport);
    yield takeLatest(
        GET_ACTIVE_MANDATE_REPORT_REQUEST,
        getActiveMandateReportDetails
    );
    yield takeLatest(
        DOWNLOAD_MANDATE_REPORT_REQUEST,
        downloadMandateReportRequest
    );
}
